import { apiFetch } from 'modules/shared/fetch';

const pageSize = 20;

export default class FreelancerVerificationService {
  static async uploadBulkVerification({
    data,
    appToken,
    appEnvironment,
  }: {
    appToken: string;
    appEnvironment: string;
    data: any;
  }) {
    const formData = new FormData();
    formData.set('file', data);

    const response = await apiFetch('/verifications/v1/freelancers/bulk', {
      // @ts-ignore
      method: 'POST',
      body: formData,
      appEnvironment,
      headers: {
        'lean-app-token': appToken,
      },
      stringifyBody: false,
      removeContentType: true,
    });

    return response?.data;
  }

  static async getVerificationRecords({
    appToken,
    appEnvironment,
    page,
  }: {
    appToken: string;
    appEnvironment: string;
    page: number;
  }) {
    const searchParams = new URLSearchParams();
    searchParams.set('page', String(page - 1));
    searchParams.set('size', String(pageSize));
    const response = await apiFetch(
      `/verifications/v1/freelancers/records?${searchParams}`,
      {
        // @ts-ignore
        method: 'GET',
        appEnvironment,
        headers: {
          'lean-app-token': appToken,
        },
      },
    );

    return response?.data;
  }

  static async getBulkVerificationResult({
    appToken,
    requestId,
    appEnvironment,
  }: {
    appToken: string;
    requestId: string;
    appEnvironment: string;
  }) {
    const response = await apiFetch(
      `/verifications/v1/freelancers/bulk/${requestId}`,
      {
        // @ts-ignore
        method: 'GET',
        appEnvironment,
        headers: {
          'lean-app-token': appToken,
        },
      },
    );

    return response?.data;
  }

  static async getBulkVerificationResultData({
    appToken,
    requestId,
    isCsvFile,
    appEnvironment,
    page,
  }: {
    appToken: string;
    requestId: string;
    isCsvFile?: boolean;
    appEnvironment: string;
    page?: number;
  }) {
    const searchParams = new URLSearchParams();
    if (!isCsvFile) {
      if (page) {
        searchParams.set('page', String(page - 1));
      }
      searchParams.set('size', String(pageSize));
    }
    const response = await apiFetch(
      `/verifications/v1/freelancers/bulk/${requestId}/results?${searchParams.toString()}`,
      {
        // @ts-ignore
        method: 'GET',
        appEnvironment,
        headers: {
          'lean-app-token': appToken,
          Accept: isCsvFile ? 'text/csv' : 'application/json',
        },
      },
    );

    return response?.data;
  }
}
